// 原型统计工具 - 使用 localStorage 模拟统计数据

const STATS_KEY = 'archetype_stats';

// 初始化默认统计数据（模拟已有用户数据）
const defaultStats = {
  ruler: 85,
  hero: 120,
  sage: 95,
  explorer: 150,
  outlaw: 70,
  magician: 88,
  lover: 130,
  jester: 110,
  everyman: 140,
  caregiver: 125,
  creator: 105,
  innocent: 98,
};

// 获取统计数据
export function getStats() {
  const saved = localStorage.getItem(STATS_KEY);
  if (saved) {
    return JSON.parse(saved);
  }
  // 首次使用，初始化默认数据
  localStorage.setItem(STATS_KEY, JSON.stringify(defaultStats));
  return defaultStats;
}

// 记录用户原型
export function recordArchetype(archetypeKey) {
  const stats = getStats();
  stats[archetypeKey] = (stats[archetypeKey] || 0) + 1;
  localStorage.setItem(STATS_KEY, JSON.stringify(stats));
  return stats;
}

// 计算某原型的稀有度百分比（比多少人更像这个原型）
export function getRarityPercentage(archetypeKey) {
  const stats = getStats();
  const total = Object.values(stats).reduce((sum, count) => sum + count, 0);
  const archetypeCount = stats[archetypeKey] || 0;
  
  if (total === 0) return 50;
  
  // 计算比例：该原型占总数的百分比
  const percentage = (archetypeCount / total) * 100;
  
  // 转换为"你比X%的人更像这个原型"
  // 原型越稀有，百分比越高
  const rarity = 100 - percentage;
  
  return Math.round(Math.max(10, Math.min(95, rarity)));
}

// 获取原型排名
export function getArchetypeRanking() {
  const stats = getStats();
  return Object.entries(stats)
    .sort((a, b) => b[1] - a[1])
    .map(([key, count], index) => ({
      key,
      count,
      rank: index + 1,
    }));
}

// 检查是否已记录过（避免重复记录）
const RECORDED_KEY = 'archetype_recorded';

export function hasRecorded() {
  return localStorage.getItem(RECORDED_KEY) === 'true';
}

export function markRecorded() {
  localStorage.setItem(RECORDED_KEY, 'true');
}

export function clearRecorded() {
  localStorage.removeItem(RECORDED_KEY);
}
